import {HttpInterceptorFn} from '@angular/common/http';

export const xSocketInterceptor: HttpInterceptorFn = (req, next) => {

  const pathExcludes: string[] = [];

  if (validatePath(req.url, pathExcludes)) {
    return next(req);
  } else {
    const authReq = req.clone({
      headers: req.headers
        .set('x-socket-id', `default`)
    });
    return next(authReq);
  }
}

const validatePath = (urlReq: string, pathList: string[]): boolean => {
  return pathList.some(pathItem => urlReq.endsWith(pathItem));
}
